import type { VisionResult } from '../types/model';

type Props = { result: VisionResult; onBack: () => void };

export function DebugView({ result, onBack }: Props) {
  return (
    <div className="app">
      <header className="app-header">
        <h1>🔧 Debug-Ansicht</h1>
      </header>
      <main>
        <button className="secondary" onClick={onBack}>Zurück zu Ergebnissen</button>
        <section className="debug-section">
          <h2>Pipeline-Details</h2>
          <p>Primärmodell: {result.model || '?'}</p>
          {result.ensemble_models && result.ensemble_models.length > 0 && (
            <p>Ensemble-Modelle: {result.ensemble_models.join(', ')}</p>
          )}
          {result.judge_model && <p>Judge-Modell: {result.judge_model}</p>}
          <p>Gesamtzeit: {result.elapsed?.toFixed(1)}s</p>
          {result.stages && (
            <div>
              <h3>Stufen</h3>
              <p>Stufe 1: Orientierung={result.stages.stage1.orientation}, Felder={result.stages.stage1.field_count}</p>
              <p>Stufe 2: {result.stages.stage2.results_count} Ergebnisse</p>
              <p>Stufe 3: Korrekturen={result.stages.stage3.corrections_applied ? 'Ja' : 'Nein'}</p>
            </div>
          )}
          {result.timing && (
            <pre className="debug-pre">{JSON.stringify(result.timing, null, 2)}</pre>
          )}
        </section>
        {result.response && (
          <section className="debug-section">
            <h2>Erkennung</h2>
            <p>Referenzkarte erkannt: {result.response.reference_card_detected ? 'Ja' : 'Nein'}</p>
            <p>Teststreifen erkannt: {result.response.test_strip_detected ? 'Ja' : 'Nein'}</p>
            <p>Orientierung: {result.response.orientation}</p>
            <p>Gesamt-Modellkonfidenz: {(result.response.overall_model_confidence * 100).toFixed(0)}%</p>
            {result.response.warnings.length > 0 && (
              <p>Warnungen: {result.response.warnings.join(', ')}</p>
            )}
          </section>
        )}
        <section className="debug-section">
          <h2>Parameter-Details</h2>
          {result.response?.results.map((r, i) => (
            <details key={i} className="debug-detail">
              <summary>{r.parameter} – {r.estimated_value ?? 'N/A'} {r.unit}</summary>
              <div className="debug-detail-body">
                <p>Modell-Konfidenz: {(r.model_confidence * 100).toFixed(0)}%</p>
                <p>Referenz: {r.lower_reference} – {r.upper_reference} {r.unit}</p>
                {r.interpolation_fraction !== null && <p>Interpolationsanteil: {(r.interpolation_fraction * 100).toFixed(0)}%</p>}
                <p>Interpoliert: {r.interpolated ? 'Ja' : 'Nein'}</p>
                <p>Status: {r.status}</p>
                <p>Testfeld: {r.test_field_description}</p>
                <p>Referenzzeile: {r.reference_row_description}</p>
                <p>Begründung: {r.reasoning_short}</p>
              </div>
            </details>
          ))}
        </section>
        {result.raw_responses && result.raw_responses.length > 0 && (
          <section className="debug-section">
            <h2>KI-Rohantworten pro Stufe</h2>
            {result.raw_responses.map((raw: any, i) => (
              <details key={i}>
                <summary>Stufe: {raw.stage} (Modell: {raw.model})</summary>
                <pre className="debug-pre">{String(raw.response).substring(0, 3000)}</pre>
              </details>
            ))}
          </section>
        )}
      </main>
    </div>
  );
}
